export default function install(Vue) {
    const moment = require('moment');
    Vue.filter('momentFormat', (string, format) => moment(string).format(format))
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/vue-moment-format-plugin.js